import Model from './Model'

export default class User extends Model {
  id: number
  firstName: string
  lastName: string
  email: string
  phone: string
  phoneVerified: boolean
  company: string
  locale: string
  updatedAt: string
  createdAt: string
  avatarID: string
  token: string
  admin: false
  companyLogoId: number

  get getLocale(): string {
    return this.locale
  }

  get getToken(): string {
    return this.token
  }

  setPhoneNumber(phone) {
    this.phone = phone
  }
}
